var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.001 6.66681C13.0033 7.54672 12.7977 8.41473 12.401 9.20014C11.9306 10.1413 11.2075 10.9329 10.3126 11.4863C9.41774 12.0397 8.38647 12.3331 7.33431 12.3335C6.4544 12.3358 5.58639 12.1302 4.80098 11.7335L1.00098 13.0001L2.26764 9.20014C1.87093 8.41473 1.66535 7.54672 1.66764 6.66681C1.66805 5.61465 1.96138 4.58337 2.51479 3.68851C3.06819 2.79364 3.85981 2.07052 4.80098 1.60014C5.58639 1.20343 6.4544 0.997847 7.33431 1.00014H7.66764C9.05721 1.0768 10.3697 1.66332 11.3537 2.64738C12.3378 3.63145 12.9243 4.94391 13.001 6.33347V6.66681Z",
    stroke: "#1600E5",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefComment);
export default __webpack_public_path__ + "static/media/ref_comment.34f1400c.svg";
export { ForwardRef as ReactComponent };